import cn from 'classnames';
import { NotifyLink } from 'components/Shared/NotifyLink';
import { useSelector } from 'react-redux';
import { rm } from 'utils';
import { getQaDataAttr } from '@bygghemmait/utilities';
import styles from './adviceAndContact.scss';
import { selectPhonenumber, selectPhoneOpen } from 'components/Footer/selector';
import { getSecondaryMenu } from 'components/MainMenu/selectors';

interface AdviceProps {
  className?: string;
}
export const Advice = ({ className }: AdviceProps) => {
  const links = useSelector(getSecondaryMenu);

  return (
    <div className={cn(styles.advice, className)}>
      <div className={styles.adviceHeader}>{rm('advice_header')}</div>
      {links.map(({ url, title, ticket, id }) => (
        <NotifyLink
          key={url}
          url={url}
          ticket={ticket}
          className={styles.adviceItem}
          {...getQaDataAttr(`link-nav-${id}`)}
        >
          {title}
        </NotifyLink>
      ))}
    </div>
  );
};

export const Contact = () => {
  const phone = useSelector(selectPhonenumber);
  const phoneOpen = useSelector(selectPhoneOpen);

  return (
    <div className={styles.contact}>
      <div>
        <div>
          <strong>{rm('footer_contact_heading')}</strong>
        </div>
        <div>{rm('footer_contact_text')}</div>
      </div>
      <div>
        <div>
          <strong>{phone}</strong>
        </div>
        <div>{phoneOpen}</div>
      </div>
    </div>
  );
};
